import api from './api';

/**
 * 公司简介
 * 1、简介视频
 * 2、简版
 * 3、长版介绍
 * @param {key:companyOrder}
 */
export function companySummaryInfos(param) {
  return api.post('/company/getCompany', param, false, false).then(res => res);
}

// 首页介绍长版
export function longCompanySummary() {
  return api.post('/company/companylong', false, true).then(res => res);
}

// 公司视频中心
export function movieCompany(params) {
  return api.post('/movie/getMovieList', params, false, false).then(res => res);
}

// 公司领导
export function leadersCompany() {
  return api.post('/lead/getLeadList', false, true).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/company.js